import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const icData = [
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Troisième Trimestre 2025 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/ICA_T3_2025.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Au troisième trimestre 2025, par rapport à 2024, le commerce au Burundi recule de 0,5 % tandis que les services progressent de 14,2 %.",
      date: "2026-02-06",
      publicationDate: "2026-02-06",
      linktableauCommerce:"/documents/indicesICA/",
      linktableauService: "/documents/indicesICA/",
      titleService: "Tableaux et Graphiques des Services",
      titleCommerce: "Tableaux et Graphiques du commerce",
      //titleMaquette: "Maquette",
  // linkMarquette: "/documents/indicesICA/Maquette-ICAB-Commerce_T3-2024.xls",
    },
   {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Deuxième Trimestre 2025 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/ICA_T2_2025.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Au deuxième trimestre 2025, par rapport à 2024, les secteurs du commerce et des services au Burundi enregistrent des croissances négatives respectives de 9,4 % et 4,4 %.",
      date: "2026-02-06",
      publicationDate: "2026-02-06",
      linktableauCommerce:"/documents/indicesICA/",
      linktableauService: "/documents/indicesICA/",
      titleService: "Tableaux et Graphiques des Services",
      titleCommerce: "Tableaux et Graphiques du commerce",
      //titleMaquette: "Maquette",
  // linkMarquette: "/documents/indicesICA/Maquette-ICAB-Commerce_T3-2024.xls",
    },
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Premier Trimestre 2025 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/RapportICAT12025.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Au premier trimestre 2025, le Burundi a enregistré une croissance positive de 14,6% dans le secteur du commerce et une contraction de 10,8% dans le secteur des services par rapport à la même période en 2024.",
      date: "2025-05-15",
      publicationDate: "2025-05-15",
      linktableauCommerce:"/documents/indicesICA/Tableaux-graphiques-Commerce-T1_2025_CORRIGE-DES-VARIATIONS.xlsx",
      linktableauService: "/documents/indicesICA/Tableaux-graphyques-Services-T1-2025_CORRIGE-DES-VARIATIONS.xlsx",
      titleService: "Tableaux et Graphiques des Services",
      titleCommerce: "Tableaux et Graphiques du commerce",
      //titleMaquette: "Maquette",
  // linkMarquette: "/documents/indicesICA/Maquette-ICAB-Commerce_T3-2024.xls",
    },
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Troisième Trimestre 2024 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/Rapport-ICA-T3-2024-VF2.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Une contraction du secteur commercial de 16,6 %, contre une croissance positive du secteur des services  de 31.6%  par rapport à la même période de 2023.",
      date: "2024-12-20",
      publicationDate: "2024-12-24",
      linktableauCommerce:"/documents/indicesICA/Tableaux-et-graphiques-Commerce-T3_2024_.xlsx",
      linktableauService: "/documents/indicesICA/Tableaux-et-graphyques-Services-T3-2024.xlsx",
      titleService: "Tableaux et Graphiques des Services",
      titleCommerce: "Tableaux et Graphiques du commerce",
      titleMaquette: "Maquette",
      linkMarquette: "/documents/indicesICA/Maquette-ICAB-Commerce_T3-2024.xls",
    },
    
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Deuxième Trimestre 2024 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/Rapport-ICA-T2-2024-16-08.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Une croissance positive du secteur commercial de 209,9%, contre une croissance positive du secteur des services  de 44,0%  par rapport à la même période de 2023.",
      date: "2024-08-16",
      publicationDate: "2024-08-16",
      linktableauCommerce:"/documents/indicesICA/Tableaux-et-graphiques-Commerce-T2_2024_CORRIGE-DES-VARIATIONS.xlsx",
      linktableauService: "/documents/indicesICA/Tableaux-et-graphyques-Services-T2-2024_CORRIGE-DES-VARIATIONS.xlsx",
      titleService: "Tableaux et Graphiques des Services",
      titleCommerce: "Tableaux et Graphiques du commerce",
      titleMaquette: "Maquette",
      linkMarquette:  "/documents/indicesICA/Maquette-ICAB-Services_T2-2024-1.xls",
    },
  
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Premier Trimestre 2024 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/Rapport-ICA-T1-2024-29-05-copy.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Une croissance positive du secteur commercial  de 41,5%, contre une croissance positive du secteur des services  de 53,9%  par rapport à la même période de 2023.",
      date: "2024-05-29",
      publicationDate: "2024-05-29",
      linktableauCommerce:"/documents/indicesICA/Tableaux-et-graphiques-Commerce-T1_2024-29-05_CORRIGE-DES-VARIATIONS.xlsx",
      linktableauService: "/documents/indicesICA/Tableaux-et-graphyques-Services-T1-2024-29-05_CORRIGE-DES-VARIATIONS.xlsx",
      titleService: "Tableaux et Graphiques des Services",
      titleCommerce: "Tableaux et Graphiques du commerce",
      titleMaquette: "Maquette",
      linkMarquette: "/documents/indicesICA/Maquette-ICAB-Services_T1-2024.xls",
    },
/*
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Quatrième Trimestre 2023 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/",
   image: 'assets/indicesICA/ica.PNG',
      description: "Comparé à la même période de 2022, le quatrième trimestre 2023 a montré une baisse négative de 11,9 % dans le secteur du commerce. Cette contraction est principalement impulsée par une chute notable dans le commerce de gros et les activités intermédiaires, ainsi que dans le commerce de produits pétroliers. Cependant, le secteur des réparations automobiles a enregistré une légère croissance de 4,9 %, témoignant de la résilience de certaines branches.",
      date: "2024-02-21",
      publicationDate: "2024-02-21"
    },
    */
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Troisième Trimestre 2023 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/Rapport-ICA-T3.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Une croissance positive du secteur commercial de 87.1%, contre une croissance positive du secteur des services  de 25.1%  par rapport à la même période de 2022.",
      date: "2023-11-30",
      publicationDate: "2023-12-05"
    },
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Deuxième Trimestre 2023 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/ICAT2-2023-fnl.pdf",
      image: 'assets/indicesICA/ica.PNG',
      description: "Une croissance négative du secteur commercial de 23.8%, contre une croissance positive du secteur des services  de 10.2%  par rapport à la même période de 2022.",
      date: "2023-08-25",
      publicationDate: "2023-08-25"
    },
    {
      title: "Rapport sur l'Indice du Chiffre d'Affaires du Premier Trimestre 2023 dans les Secteurs « Commerce » et « Autres Services »",
      link: "/documents/indicesICA/Rapport-ICA-T1_2605-rev-gitega-3.docx",
      image: 'assets/indicesICA/ica.PNG',
      description: "Une croissance négative du secteur commercial  de 23.3% , contre une croissance positive du secteur des services  de 20.0%  par rapport à la même période de 2022.",
      date: "2023-05-26",
      publicationDate: "2023-05-28"
    },
];

function IndiceChiffreAffaires() {
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredIC, setFilteredIC] = useState(icData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredIC(icData);
    } else {
      const filtered = icData.filter((indice) => {
        const indiceYear = new Date(indice.date).getFullYear();
        return indiceYear === parseInt(year);
      });
      setFilteredIC(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: '500',
        fontSize: '1rem',
        textTransform: 'none',
        color: '#3B3F54',
      },
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <br />
        <br />
   
        <Container maxWidth="lg" style={{ paddingTop: '24px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Indice du Chiffre d'Affaires au Burundi (ICA)
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le secteur tertiaire constitué des activités commerciales et des services fait appel à l'Indice du Chiffre d'Affaires des services (commerce et autres services) qui est un indicateur permettant de mesurer l'évolution, période par période du chiffre d'affaire réalisé par les entreprises de ce secteur.
          </Typography>

          <FormControl variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de publication"
            >
              <MenuItem value="Tous">Tous les indices</MenuItem>
              {[...new Set(icData.map((indice) => new Date(indice.date).getFullYear()))]
                .sort((a, b) => b - a)
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredIC.slice(0, visibleCount).map((indice, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a href={indice.link} style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
                      <CardMedia
                        component="img"
                        sx={{ width: 101, height: 160, m: 2 }}
                        image={indice.image}
                        alt={indice.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a href={indice.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                        {<DownloadIcon />}{indice.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" style={{ color: '#555', marginBottom: '10px' }}>
                         {indice.description}
                      </Typography>
                      <Typography variant="caption" style={{ color: '#555' }}>
                      <a href={indice.linktableauCommerce} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#00A3E0' }}>
                             {indice.titleCommerce}
                        </a>

                      </Typography>
                      <Typography variant="caption" style={{ color: '#555'}}>
                      <a href={indice.linktableauService} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#00A3E0' }}>
                           {indice.titleService}
                        </a>
                      </Typography>
                      <Typography variant="caption" style={{ color: '#555'}}>
                      <a href={indice.linktableauService} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#00A3E0' }}>
                           {indice.titleMaquette}
                        </a>
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(indice.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginTop: '20px' }}>
            {visibleCount < filteredIC.length && (
              <Button
                onClick={handleShowMore}
                variant="contained"
                style={{
                  marginTop: '5px',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                  marginBottom: '10px',
                }}
              >
                Plus d'Indices
              </Button>
            )}
          </Box>

          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
            <strong>Note :</strong> Les indices du chiffre d'affaires sont publiés trimestriellement, généralement <strong>45 jours</strong> après la fin de chaque trimestre, ce qui correspond aux dates suivantes :
            <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>15 février</strong> - Fin du quatrième trimestre </li>
              <li><strong>15 mai</strong> - Fin du premier trimestre </li>
              <li><strong>15 août</strong> - Fin du deuxième trimestre </li>
              <li><strong>15 novembre</strong> - Fin du troisième trimestre</li>
            </ul>
          </Typography>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button 
              onClick={() => navigate('/indice')} 
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des indices
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default IndiceChiffreAffaires;